



















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';

import BaseComponent from '@/components/base-component.vue';

@Component
export default class UiSelectStatus extends BaseComponent {
  @Prop()
  public value: any[];
  @Prop()
  public items!: any[];
  @Prop({
    default: 'Status',
  })
  public label?: string;

  public selectedItems: any[] = [];

  @Watch('value')
  public onValueChange(val: any[]): void {
    this.selectedItems = val;
    this.$emit('changeStatus', val);
  }

  @Watch('selectedItems')
  public onSelectedItemsChange(val: any[]): void {
    this.$emit('input', val);
  }

  public beforeMount(): void {
    this.selectedItems = this.value;
  }

  public onChange(val): void {
    this.$emit('change', val);
  }

  public toggleSelectAll(): void {
    if (this.isAllSelected()) {
      this.selectedItems = [];
    } else {
      this.selectedItems = this.items.map((item) => item.key);
    }
  }

  public isAllSelected(): boolean {
    return this.items.length === this.value.length;
  }
}
